export const DRAWER_WIDTH = "w-[700px]";
export const PAGE_BESIDE_DRAWER = "md:pr-[700px]";
